/**
 * The external dependencies.
 */
import axios from 'axios';
import moment from 'moment';
import * as R from 'ramda';
import Workplaces from '../assets/data/workplaces.json';

/**
 * The internal dependencies.
 */
// const BASERURL = 'http://localhost:8090/api-v1';
const BASERURL = process.env.API_URL;

const client = axios.create({
    baseURL: BASERURL,
    withCredentials: true,
    mode: 'cors',
    crossdomain: true,
});

const routes = {
        login(username, password) {
            return new Promise((resolve, reject) => {

                client.post(BASERURL + '/fe/login', JSON.stringify({
                    username: username,
                    password: password,
                }), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {

                    if (response.status == 200) {

                        const myResolve = function () {
                            resolve({
                                data: {
                                    ...response.data,
                                    fullname: response.data.firstname + " " + response.data.lastname,
                                }
                            })
                        };

                        window.setTimeout(myResolve, 2000);


                    } else {
                        reject('Something is wrong. Please try login again.')
                    }

                })
                    .catch(function (error) {
                        reject('The password or the username was wrong inserted')
                    });

            });
        },
        checkLogin() {

            return new Promise((resolve, reject) => {

                client.get(BASERURL + '/fe/checkLogin').then(function (response) {

                    resolve({data: {data: response.data, status: response.status}});

                }).catch(function (error) {
                    // console.log("checkloginERROR", error);
                    resolve({data: {data: error, status: 444}});
                });

            });
        },
        logout() {

            return new Promise((resolve, reject) => {

                client.get(BASERURL + '/fe/logout').then(function (response) {
                    if (response.status == 200) {
                        resolve(response)
                    } else {

                        reject("Something is wrong. Please try to logout again lately.");
                    }
                })
                    .catch(function (error) {
                        reject(error)
                    });

            });
        },

        /**
         * get task per week by a given date
         *
         * @param sortingPaginationValue (moment)
         * @returns {Promise}
         */
        getTasks(sortingPaginationValue) {
            return new Promise((resolve, reject) => {
                const start = moment(sortingPaginationValue).startOf('week').subtract(3, 'hour').format('YYYY-MM-DD');
                const end = moment(sortingPaginationValue).startOf('week').add(5, 'day').format('YYYY-MM-DD');


                const query = {
                    search: `date>${start}T23:00:00.000+01:00,date<${end}T01:00:00.000+01:00`,
                    size: 1000, projection: 'details'
                };
                client.get(BASERURL + '/task/search/dslquery', {params: query})
                    .then(function (response) {
                            if (response.status !== 200) {
                                reject(false);
                            } else if (!response.data._embedded) {
                                resolve({data: {orders: [], tasks: []}});
                            } else {
                                const tasks = response.data._embedded.task;
                                const distinctOrderIDs = [...new Set(tasks.map(t => t.order_id))];
                                // callRoute(['getOrders'])
                                getOrdersById(distinctOrderIDs)
                                    .then(res => {
                                        resolve({data: {orders: res, tasks: tasks}});
                                    })
                                    .catch(() => resolve({data: {orders: [], tasks: []}}));
                            }
                        }
                    )
                    .catch(function (error) {
                        resolve({data: {orders: [], tasks: []}});
                    });
            });
        },

        getOrders() {
            // Simulate API request
            return new Promise((resolve, reject) => {

                client.get(BASERURL + '/order', {params: {size: 1000}}).then(function (response) {
                    if (response.status == 200) {
                        resolve(response.data._embedded.order)
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });
            });
        },

        getUserDetail() {
            // Simulate API request
            return new Promise((resolve, reject) => {

                client.get(BASERURL + '/user/search/profil?projection=detail').then(function (response) {
                    if (response.status == 200) {
                        resolve({data: response.data});
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve({data: ''});
                    });

            });
        },

        getTaskChildren(params) {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/task/search/cgetChildren?projection=detail&owner=' + params.id)
                    .then(function (response) {
                        if (response.status === 200) {
                            resolve({data: response.data});
                        } else {
                            reject(false);
                        }
                    })
                    .catch(function (error) {
                        resolve({data: ''});
                    });

            });
        },

        getConfig() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/clientConfig/list')
                    .then(function (response) {
                        if (response.status === 200) {
                            resolve({data: response.data});
                        } else {
                            reject(false);
                        }
                    })
                    .catch(function (error) {
                        resolve({data: []});
                    });

            });
        },

        async updateTask(params) {

            return new Promise((resolve, reject) => {
                if (params.task === undefined) reject(false);
                let updatePath = params.task.worker === '' ? '/freetask' : '/reserve';
                client.put(params.task._links.self.href + updatePath, JSON.stringify(params.task), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {

                    if (response.status == 200) {

                        resolve("update-tasks-success");

                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });

            });
        },

        async dispoUpdateTask(params) {

            return new Promise((resolve, reject) => {
                if (params.task === undefined) reject(false);
                let updatePath = '/dispo';
                client.put(params.task._links.self.href + updatePath, JSON.stringify(params.task), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {

                    if (response.status == 200) {

                        resolve("update-tasks-success");

                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });

            });
        },

        async pauseTask(params) {

            return new Promise((resolve, reject) => {
                if (params.task === undefined) reject(false);
                let updatePath = '/pausetask';
                client.put(params.task._links.self.href + updatePath, JSON.stringify(params.task), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {

                    if (response.status == 200) {

                        resolve("update-tasks-success");

                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });

            });
        },

        getTasksSteps(params) {
            return new Promise((resolve, reject) => {
                let queryString = "client" + encodeURIComponent('%' + params.client) + ",erpnumber" + encodeURIComponent('%' + params.erpnumber);
                client.get(BASERURL + '/instruction/search/dslquery?search=' + queryString).then(function (response) {
                    if (response.status == 200) {
                        resolve({data: response.data});
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });
            });
        },

        getTasksHandbook(params) {
            return new Promise((resolve, reject) => {
                let queryString = "client" + encodeURIComponent('%' + params.client) + ",erpnumber" + encodeURIComponent('%' + params.erpnumber);
                client.get(BASERURL + '/handbook/search/dslquery?search=' + queryString).then(function (response) {
                    if (response.status == 200) {
                        try{
                            client.get(response.data['_embedded'].handbook[0]._links.resourcesEntityPdf.href).then(value => {
                                resolve({data: value.data});
                            })
                        } catch (e) {
                            reject(response);
                        }
                    } else {
                        reject(response);
                    }
                })
                    .catch(function (error) {
                        reject(error)
                    });
            });
        },

        getTasksWorkSteps() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/workstep/user').then(function (response) {
                    if (response.status == 200) {
                        if (response.data._embedded) {
                            resolve({data: R.pluck('content')(response.data._embedded.persistentEntityResources)});
                        }
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });
            });
        },

        getAllTasksWorkSteps() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/workstep/all').then(function (response) {
                    if (response.status == 200) {
                        if (response.data._embedded) {
                            resolve({data: R.pluck('content')(response.data._embedded.persistentEntityResources)});
                        }
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });
            });
        },

        getTasksWorkplaces() {
            return new Promise((resolve, reject) => {
                resolve({
                    data: {
                        workplaces: Workplaces,
                    }
                });
            });
        },

        callWorkPlanner() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/email/informArbeitsplaner').then(function (response) {
                    if (response.status == 200) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });
            });

        },

        callProductionManager(params) {

            return new Promise((resolve, reject) => {
                    client.post(BASERURL + '/email/informFertigungsleiter', {
                        "message": params.message,
                        "taskid": params.taskid
                    })
                        .then(function (response) {
                            if (response.status == 200) {
                                resolve(true);
                            } else {
                                reject(false);
                            }
                        })
                        .catch(function (error) {
                            resolve(false)
                        });
                }
            )
                ;

        },

        callDispatcher() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/email/informDisponent').then(function (response) {
                    if (response.status == 200) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });
            });

        }
        ,

        callQa(task) {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/email/informQuali/' + returnId(task._links.self.href)).then(function (response) {
                    if (response.status == 200) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });
            });

        }
        ,

        getWarnings(task, order) {
            return new Promise((resolve, reject) => {
                let queryString = "erpnumber" + encodeURIComponent('%' + task.erpnumber) + ",client" + encodeURIComponent('%' + order.client) + ",deleted:false";
                client.get(BASERURL + '/errorreport/search/dslquery?search=' + queryString).then(function (response) {
                    if (response.status == 200) {
                        if (response.data._embedded === undefined) {
                            resolve({data: []});
                        } else {
                            resolve({data: response.data._embedded.errorreport});
                        }
                    } else {
                        reject(false);
                    }
                })
                    .catch(function (error) {
                        resolve(false)
                    });
            });
        }
        ,

        submitErrorReport(data, photos) {
            return new Promise((resolve, reject) => {

                client.post(BASERURL + '/errorreport', data)
                    .then(function (response) {
                        if (response.status >= 200 && response.status < 300) {
                            // resolve({data: response.data._embedded.errorreport});
                            let cid = returnId(response.data._links.self.href);
                            let upload = uploadErrorPictures(cid, photos);
                            if (upload !== undefined) {
                                upload.then(
                                    function (picresponse) {
                                        resolve(true);
                                    }
                                ).catch(function (picerror) {
                                    resolve(false);
                                });
                            }

                        } else {
                            reject(false);
                        }
                    })
                    .catch(function (error) {
                        resolve(false);
                    });
            });
        }
        ,

        startTracking(tasktracking) {
            return new Promise((resolve, reject) => {
                client.post(BASERURL + '/tasktracking', tasktracking)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(false);
                    });
            });
        }
        ,

        closeTracking(uuid) {
            return new Promise((resolve, reject) => {
                client.put(BASERURL + '/tasktracking/' + uuid + '/close')
                    .then(function (response) {
                        resolve({data: ''});
                    })
                    .catch(function (error) {
                        reject(false);
                    });
            });
        }
        ,

        acceptError(acceptreport) {
            return new Promise((resolve, reject) => {
                client.post(BASERURL + '/acceptreport', acceptreport)
                    .then(function (response) {
                        resolve({data: ''});
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }
        ,

        getErrortracking() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/errortracking', {params: {size: 1000}})
                    .then(function (response) {
                        resolve({data: response.data._embedded.errortracking});
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }
        ,

        getDetails(uuid) {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/errortracking/' + uuid + '/details')
                    .then(function (response) {
                        resolve({data: response.data});
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }
        ,

        getworkstepcount() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/workstepcount')
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }
        ,

        getWorkerForDispo() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/user/dispo', {
                    params: {
                        projection: 'detaildispo'
                    }
                })
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }
        ,

        getDepartmentForDispo() {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/department/all', {
                    params: {
                        projection: 'detaildispo'
                    }
                })
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }
        ,

        getDepartmentConfig(params) {
            return new Promise((resolve, reject) => {
                client.get(BASERURL + '/departmentconfig/task/{uuid}'.replace('{uuid}', params.id))
                    .then(function (response) {
                        // console.log("getDepartmentConfig", response);
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
            });
        }
        ,

    }
;

function uploadErrorPictures(id, photos) {
    let data = new FormData();
    if (photos === undefined) return undefined;
    // for (var i = 0; i < photos.length; i++) {

    for (let i = 1; i <= 3; i++) {
        let myphoto = photos[i - 1];
        if (photos[i - 1] !== null && photos[i - 1] !== undefined) {
            let file = dataURLtoFile(photos[i - 1], 'image-' + i + '.png');
            data.append('file_' + i, file, file.name);
        } else {
            data.append('file_' + i, null, 'empty');
        }

    }

    const config = {
        headers: {'content-type': 'multipart/form-data'},
        baseURL: BASERURL,
        withCredentials: true,
        mode: 'cors',
        crossdomain: true,
    };

    return axios.post(BASERURL + '/upload/errorreport/' + id, data, config)
}

function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
}

//Usage example:
// var file = dataURLtoFile('data:text/plain;base64,aGVsbG8gd29ybGQ=', 'hello.txt');

export async function callRoute([route, ...params]) {
    const callback = routes[route];
    return callback ? await callback(...params) : null;
}

export async function getOptionsQuery(value, query) {
    return new Promise((resolve, reject) => {
        client.get(BASERURL + value, {params: query})
            .then(function (response) {
                // console.log("getDepartmentConfig", response);
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            });
    });
}
/**
 * get all orders by an array of order ids
 *
 * @param {Array} ids
 */
export async function getOrdersById(ids) {
    return new Promise((resolve, reject) => {
        client.post(BASERURL + '/order/search/custom/list', ids).then(value => {
            resolve(value.data._embedded.order);
        }).catch(reason => {
            reject(reason);
        })
    });
}

export function returnId(string) {
    return '' + R.replace(/{\?.+}/gm, '', R.last(R.split('/', string)));
}



// WEBPACK FOOTER //
// ./src/common/api.js